import * as Analytics from 'analytics/analytics'
import { searchEventWithContext } from 'analytics/snowplow/events'
import { useCallback } from 'react'
import type {
  SearchContext_1_0_3,
  Filter_1_0_0,
  Sort_1_0_0,
  Search_3_0_0,
} from '@luxuryescapes/contract-data-event-schemas/lib/com.luxgroup'

export function useSearchAnalytics({
  searchEvent,
  searchContext,
  filterContexts = [],
  sortContext = { value: 'recommended' },
  searchSessionId,
}: {
  searchEvent?: Search_3_0_0
  searchContext?: SearchContext_1_0_3
  filterContexts?: Array<Filter_1_0_0>
  sortContext?: Sort_1_0_0
  searchSessionId?: string
}) {
  const trackSearchEvent = useCallback(() => {
    if (searchEvent && searchContext) { Analytics.trackEvent(searchEventWithContext({
      searchEvent,
      searchContext,
      filterContexts,
      sortContext,
      searchSessionId,
    })) }
  }, [searchEvent, searchContext, filterContexts, sortContext, searchSessionId])

  return {
    trackSearchEvent,
  }
}

export default useSearchAnalytics
